import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ColumnFields, TableFilter } from '../../utils/dataTable/data';
import { RootState } from '../rootReducer';

export interface TeamViewState {
  fields: ColumnFields;
  filters: TableFilter[];
}

const initialState: TeamViewState = {
  fields: {},
  filters: []
};

const getTeamsViewState = (state:RootState): TeamViewState => state.adminDashboard.teams;
const getFilters = (state: RootState):TableFilter[] => getTeamsViewState(state).filters;
const getTeamsDashboardFields = (state: RootState): ColumnFields => getTeamsViewState(state).fields;

export const selectors = {
  getFilters,
  getTeamsDashboardFields
};

const teamsViewSlice = createSlice({
  name: 'teamsViewAdminDashboard',
  initialState,
  reducers : {
    setTeamsDashboardFields: (state: TeamViewState, action: PayloadAction<ColumnFields>) => {
      state.fields = action.payload;
    },
    filterTable: (state: TeamViewState, action: PayloadAction<TableFilter>) => {
      const { key, value } = action.payload;
      const otherFilters = state.filters.filter(colFilter => colFilter.key !== key);
      if (value === '' || value === undefined || value === null) {
        state.filters = otherFilters;
        return;
      }
      state.filters = [...otherFilters, action.payload];
    },
    resetfilterTable: (state: TeamViewState) => { // TODO, Temporal change, delete once new filters are added to Teams Dashboard
      state.filters = [];
    }
  }
});

export const actions = { ...teamsViewSlice.actions };
export default teamsViewSlice.reducer;
